import * as React from 'react'


export default class Container extends React.Component<any, any>{

    public render(){
        return (
            <div className="container">
                {this.props.children}
            </div>
        )
    }
        

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/isaver-quote/components/container.tsx